import {
  Component,
  OnInit,
  Inject,
  Input,
  OnDestroy,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
  ChangeDetectorRef,
  AfterViewChecked,
  Type,
} from "@angular/core";
import * as _ from "lodash";
import { MatDialog, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { GunningsService } from "src/app/services/gunnings/gunnings.service";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { variable } from "@angular/compiler/src/output/output_ast";
import { FormControl, FormGroup } from "@angular/forms";
import { IncidentsService } from "src/app/services/incidents/incidents.service";
import * as _moment from "moment";
import { T } from "@angular/cdk/keycodes";
import { ToastrService } from "ngx-toastr";
import { MatTableDataSource } from "@angular/material/table";
import { MatPaginator } from "@angular/material/paginator";

@Component({
  selector: "app-root",
  templateUrl: "./gunnings-modal.component.html",
  styleUrls: ["./gunnings-modal.component.scss"],
})
export class GunningsModalComponent implements OnInit {
  addCampaignForm: FormGroup = new FormGroup({});
  editCampaignForm: FormGroup = new FormGroup({});
  addSteelProductionForm: FormGroup = new FormGroup({});
  editSteelProductionForm: FormGroup = new FormGroup({});
  addFrimagConsumptionForm: FormGroup = new FormGroup({});
  editFrimagConsumptionForm: FormGroup = new FormGroup({});
  addMagsolConsumptionForm: FormGroup = new FormGroup({});
  editMagsolConsumptionForm: FormGroup = new FormGroup({});

  displayedColumnsAlarmsByCampaign: string[];
  dataSourceAlarmsByCampaign: MatTableDataSource<any> = new MatTableDataSource(
    []
  );
  @ViewChild("campaignAlarmsPaginator") campaignAlarmsPaginator: MatPaginator;

  displayedColumnsAlarmsByOperation: string[];
  dataSourceAlarmsByOperation: MatTableDataSource<any> = new MatTableDataSource(
    []
  );
  @ViewChild("operationAlarmsPaginator") operationAlarmsPaginator: MatPaginator;

  displayedColumnsIntervalsByOperation: string[] = [
    "id",
    "inicio",
    "fin",
    "cantidad",
  ];
  dataSourceIntervalsByOperation: MatTableDataSource<any> =
    new MatTableDataSource([]);
  @ViewChild("operationIntervalsPaginator")
  operationIntervalsPaginator: MatPaginator;

  displayedColumnsIntervalsReportSandByOperation: string[] = [
    "id",
    "inicio",
    "fin",
    "cantidad",
  ];
  dataSourceIntervalsReportSandByOperation: MatTableDataSource<any> =
    new MatTableDataSource([]);
  @ViewChild("operationIntervalsReportSandPaginator")
  operationIntervalsReportSandPaginator: MatPaginator;

  displayedColumnsIntervalsReportCatalystByOperation: string[] = [
    "id",
    "inicio",
    "fin",
    "cantidad",
  ];
  dataSourceIntervalsReportCatalystByOperation: MatTableDataSource<any> =
    new MatTableDataSource([]);
  @ViewChild("operationIntervalsReportCatalystPaginator")
  operationIntervalsReportCatalystPaginator: MatPaginator;

  displayedColumnsIntervalsReportSilicateByOperation: string[] = [
    "id",
    "inicio",
    "fin",
    "cantidad",
  ];
  dataSourceIntervalsReportSilicateByOperation: MatTableDataSource<any> =
    new MatTableDataSource([]);
  @ViewChild("operationIntervalsReportSilicatePaginator")
  operationIntervalsReportSilicatePaginator: MatPaginator;

  displayedColumnsOperationsByCampaign: string[] = [
    "id",
    "inicio",
    "fin",
    "duracion",
    "producto",
    "agua",
  ];
  dataSourceOperationsByCampaign: MatTableDataSource<any> =
    new MatTableDataSource([]);
  @ViewChild("operationsCampaignPaginator")
  operationsCampaignPaginator: MatPaginator;

  displayedColumnsIntervalsByCampaign: string[] = [
    "id",
    "inicio",
    "fin",
    "duracion",
    "arena",
    "silicato",
    "catalizador",
  ];
  dataSourceIntervalsByCampaign: MatTableDataSource<any> =
    new MatTableDataSource([]);
  @ViewChild("intervalsCampaignPaginator")
  intervalsCampaignPaginator: MatPaginator;

  wait: boolean = false;
  isPrintEnabled: boolean = false;

  HEATMAP_WATER_DATA: any[];
  HEATMAP_PRODUCT_DATA: any[];
  heatmap_anotations;
  product_heatmap_x: any[];
  product_heatmap_y: any[];
  product_heatmap_data = {
    data: [],
    layout: {},
  };

  water_heatmap_x: any[];
  water_heatmap_y: any[];
  water_heatmap_data = {
    data: [],
    layout: {},
  };

  bar_x: any[];
  bar_y: any[];
  bar_data = {
    data: [],
    layout: {},
  };

  pie_x: any[];
  pie_y: any[];
  pie_data = {
    data: [],
    layout: {},
  };

  operations_gantt_data = {
    data: [],
    layout: {},
  };

  // PDF variables
  counter: number = 0;
  length: number = 0;
  pdf: jsPDF;
  headerPDFContent: any;
  headerContentHeight: number = 0;
  report_header = "report_header";
  report_divs_operation = [
    "report_graph_product",
    "report_graph_water",
    "report_alarms",
  ];
  report_divs_campaign = [
    "report_graph_operations_chart",
    "report_kpis",
    "report_graph_product",
    "report_graph_water",
    "report_alarms_chart",
  ];

  // Collection MongoDB
  collectionCampaigns = "campaigns";
  collectionNameConsumptionsFrimag = "consumptions_frimag";
  collectionNameConsumptionsMagsol = "consumptions_magsol";
  collectionNameSteelProduction = "steel_production";
  collectionNameGunningIntervals = "cf9d103e-ce1a-4696-b29e-c26348c2b11e";

  // Gunitadora UUID (Para obtener timeseries)
  gunningDispUuid = "921ec270-541c-46e5-a98d-1dfcd0561ddf";
  gunningTipoDato = "f18f1a98-95b6-4989-8570-b247c09c2b9e";

  // Valocity Indictators
  catalystEngineVelocity: string = "0";
  sandEngineVelocity: string = "0";
  silicateEngineVelocity: string = "0";

  // KPIs
  steelProductionQuantity: number = 0;
  consumedProductQuantity: number = 0;
  consumedMagsolQuantity: number = 0;
  consumedFrimagQuantity: number = 0;
  consumedWaterQuantity: number = 0;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private gunningsService: GunningsService,
    private incidentsService: IncidentsService,
    public dialog: MatDialog,
    private toastService: ToastrService
  ) {}

  ngOnInit() {
    this.doGenerateFormControls(); // Incializar los controles de los formularios

    if (this.data.option == -1 && this.data.id == -1 && this.data.type == 0) {
      // Añadir Campaña
      this.addCampaignForm.controls.campaignName.setValue(this.data.name);
      this.addCampaignForm.controls.dispUuid.setValue(this.data.disp);
    } else if (this.data.option == 0 && this.data.type == 0) {
      // Editar Campaña
      this.editCampaignForm.controls.campaignName.setValue(
        this.data.metadata.name
      );
      this.editCampaignForm.controls.campaignUuid.setValue(
        this.data.metadata.uuid
      );
      this.editCampaignForm.controls.dispUuid.setValue(this.data.metadata.disp);
      this.editCampaignForm.controls.campaignStartDate.setValue(
        _moment(this.data.metadata.start * 1000)
      );
      this.editCampaignForm.controls.campaignEndDate.setValue(
        _moment(this.data.metadata.end * 1000)
      );
    } else if (
      this.data.option == -1 &&
      this.data.id == -1 &&
      this.data.type == 2
    ) {
      // Añadir Producción Acero
      this.addSteelProductionForm.controls.dispUuid.setValue(this.data.disp);
    } else if (
      this.data.option == -1 &&
      this.data.id == -1 &&
      this.data.type == 3
    ) {
      // Añadir Consumo Frimag
      this.addFrimagConsumptionForm.controls.dispUuid.setValue(this.data.disp);
    } else if (
      this.data.option == -1 &&
      this.data.id == -1 &&
      this.data.type == 4
    ) {
      // Añadir Consumo Magsol
      this.addMagsolConsumptionForm.controls.dispUuid.setValue(this.data.disp);
    } else if (this.data.option == 0 && this.data.type == 2) {
      // Editar Producción Acero
      this.editSteelProductionForm.controls.steelConsumption.setValue(
        this.data.metadata.consumption
      );
      this.editSteelProductionForm.controls.steelCastings.setValue(
        this.data.metadata.castings
      );
      this.editSteelProductionForm.controls.dispUuid.setValue(
        this.data.metadata.disp
      );
      this.editSteelProductionForm.controls.consumptionTimestamp.setValue(
        _moment(this.data.metadata.timestamp * 1000)
      );
    } else if (this.data.option == 0 && this.data.type == 3) {
      // Editar Consumo Frimag
      this.editFrimagConsumptionForm.controls.frimagConsumption.setValue(
        this.data.metadata.consumption
      );
      this.editFrimagConsumptionForm.controls.dispUuid.setValue(
        this.data.metadata.disp
      );
      this.editFrimagConsumptionForm.controls.consumptionTimestamp.setValue(
        _moment(this.data.metadata.timestamp * 1000)
      );
    } else if (this.data.option == 0 && this.data.type == 4) {
      // Editar Consumo Magsol
      this.editMagsolConsumptionForm.controls.magsolConsumption.setValue(
        this.data.metadata.consumption
      );
      this.editMagsolConsumptionForm.controls.dispUuid.setValue(
        this.data.metadata.disp
      );
      this.editMagsolConsumptionForm.controls.consumptionTimestamp.setValue(
        _moment(this.data.metadata.timestamp * 1000)
      );
    } else if (this.data.option == 2 && this.data.type == 1) {
      // Consumo de Producto (Operación)
      this.doRetrieveGunningProductDataById(this.data.id);
    } else if (this.data.option == 3 && this.data.type == 1) {
      // Conusmo de Agua (Operación)
      this.doRetrieveGunningWaterDataById(this.data.id);
    } else if (this.data.option == 5 && this.data.type == 1) {
      // Informe de Producción (Operación)
      this.doBuildGunningOperationReport(this.data.id);
    } else if (this.data.option == 3 && this.data.type == 0) {
      // Informe de Producción (Campaña)
      this.doBuildGunningCampaignReport(this.data.id);
    } else if (this.data.option == 4 && this.data.type == 0) {
      // KPIs de Campaña
      this.doBuildCampaignReportKPISection(
        this.data.disp,
        this.data.inicio,
        this.data.fin
      );
    }
  }

  ngAfterViewInit() {
    if (this.data.option == 2 && this.data.type == 0) {
      if (this.data.alarms.length > 0) {
        this.displayedColumnsAlarmsByCampaign = ["alarma", "timestamp"];
        this.dataSourceAlarmsByCampaign = new MatTableDataSource(
          this.data.alarms
        );
        this.campaignAlarmsPaginator.pageSize = 5;
        this.campaignAlarmsPaginator.pageIndex = 0;
        this.campaignAlarmsPaginator.length = this.data.alarms.length;
        this.dataSourceAlarmsByCampaign.paginator =
          this.campaignAlarmsPaginator;
      }
    } else if (this.data.option == 4 && this.data.type == 1) {
      if (this.data.alarms.length > 0) {
        this.displayedColumnsAlarmsByOperation = ["alarma", "timestamp"];
        this.dataSourceAlarmsByOperation.data = this.data.alarms;
        this.operationAlarmsPaginator.pageSize = 5;
        this.operationAlarmsPaginator.pageIndex = 0;
        this.operationAlarmsPaginator.length = this.data.alarms.length;
        this.dataSourceAlarmsByOperation.paginator =
          this.operationAlarmsPaginator;
      }
    }
  }

  doGenerateFormControls() {
    this.addCampaignForm.addControl(
      "dispUuid",
      new FormControl({ value: "", disabled: true })
    );
    this.addCampaignForm.addControl(
      "campaignName",
      new FormControl({ value: "", disabled: true })
    );
    this.addCampaignForm.addControl("campaignStartDate", new FormControl(""));
    this.addCampaignForm.addControl("campaignEndDate", new FormControl(""));
    this.editCampaignForm.addControl(
      "dispUuid",
      new FormControl({ value: "", disabled: true })
    );
    this.editCampaignForm.addControl(
      "campaignUuid",
      new FormControl({ value: "", disabled: true })
    );
    this.editCampaignForm.addControl("campaignName", new FormControl(""));
    this.editCampaignForm.addControl("campaignStartDate", new FormControl(""));
    this.editCampaignForm.addControl("campaignEndDate", new FormControl(""));
    this.addSteelProductionForm.addControl(
      "dispUuid",
      new FormControl({ value: "", disabled: true })
    );
    this.addSteelProductionForm.addControl(
      "steelConsumption",
      new FormControl("")
    );
    this.addSteelProductionForm.addControl(
      "steelCastings",
      new FormControl("")
    );
    this.addSteelProductionForm.addControl(
      "consumptionTimestamp",
      new FormControl("")
    );
    this.editSteelProductionForm.addControl(
      "dispUuid",
      new FormControl({ value: "", disabled: true })
    );
    this.editSteelProductionForm.addControl(
      "steelConsumption",
      new FormControl("")
    );
    this.editSteelProductionForm.addControl(
      "steelCastings",
      new FormControl("")
    );
    this.editSteelProductionForm.addControl(
      "consumptionTimestamp",
      new FormControl("")
    );
    this.addFrimagConsumptionForm.addControl(
      "dispUuid",
      new FormControl({ value: "", disabled: true })
    );
    this.addFrimagConsumptionForm.addControl(
      "frimagConsumption",
      new FormControl("")
    );
    this.addFrimagConsumptionForm.addControl(
      "consumptionTimestamp",
      new FormControl("")
    );
    this.editFrimagConsumptionForm.addControl(
      "dispUuid",
      new FormControl({ value: "", disabled: true })
    );
    this.editFrimagConsumptionForm.addControl(
      "frimagConsumption",
      new FormControl("")
    );
    this.editFrimagConsumptionForm.addControl(
      "consumptionTimestamp",
      new FormControl("")
    );
    this.addMagsolConsumptionForm.addControl(
      "dispUuid",
      new FormControl({ value: "", disabled: true })
    );
    this.addMagsolConsumptionForm.addControl(
      "magsolConsumption",
      new FormControl("")
    );
    this.addMagsolConsumptionForm.addControl(
      "consumptionTimestamp",
      new FormControl("")
    );
    this.editMagsolConsumptionForm.addControl(
      "dispUuid",
      new FormControl({ value: "", disabled: true })
    );
    this.editMagsolConsumptionForm.addControl(
      "magsolConsumption",
      new FormControl("")
    );
    this.editMagsolConsumptionForm.addControl(
      "consumptionTimestamp",
      new FormControl("")
    );
  }

  doBuildGunningCampaignReport(uuid) {
    this.gunningsService
      .getCampaignById(this.collectionCampaigns, uuid)
      .subscribe(
        (data) => {
          console.log(data);
          let campaign = data.data.findCampaignById;
          this.doBuildCampaignReportOperationsSection(
            this.gunningDispUuid,
            campaign.inicio,
            campaign.fin
          );
          this.doBuildCampaignReportKPISection(
            this.gunningDispUuid,
            campaign.inicio,
            campaign.fin
          );
          this.doBuildCampaignReportProductSection(campaign);
          this.doBuildCampaignReportWaterSection(campaign);
          this.doBuildCampaignReportAlarmsSection(
            campaign.inicio,
            campaign.fin
          );
          setTimeout(() => {
            console.log("Building report for Campaign UUID -> ", campaign._id);
            console.log("Alarms -> ", this.data.report.alarms);
            this.doBuildCampaignReportHeaderSection(
              campaign,
              this.data.report.alarms
            );
            this.isPrintEnabled = true;
          }, 10000);
        },
        (err) => {
          console.log(err);
        }
      );
  }

  doBuildCampaignReportOperationsSection(disp, inicio, fin) {
    let gantt_traces = [];
    let gantt_layout = {
      yaxis: {
        showgrid: true,
        zeroline: false,
        showline: false,
        showticklabels: false,
      },
    };
    let productTraceValues = [];
    let waterTraceValues = [];
    let operationTraceValues = [];

    this.gunningsService
      .getOperationsByGunningMachineBetweenDates(
        this.collectionNameGunningIntervals,
        disp,
        inicio,
        fin
      )
      .subscribe(
        (data) => {
          console.log(data);
          let operations = data.data.findIntervalsBetweenDates;
          let paginator = this.operationsCampaignPaginator;
          this.dataSourceOperationsByCampaign.data = operations;
          paginator.pageSize = 10;
          paginator.pageIndex = 0;
          paginator.length = operations.length;
          this.dataSourceOperationsByCampaign.paginator = paginator;
          // Build Data for Gantt Chart
          for (let i = 0; i < operations.length; i++) {
            let operation = operations[i];
            if (
              operation.campos.productoGunitadoTotal !== undefined &&
              operation.campos.productoGunitadoTotal != null
            )
              productTraceValues.push(
                this.doRoundNumber(operation.campos.productoGunitadoTotal)
              );
            else productTraceValues.push(0);
            if (
              operation.campos.peticionAgua.total !== undefined &&
              operation.campos.peticionAgua.total != null
            )
              waterTraceValues.push(
                this.doRoundNumber(operation.campos.peticionAgua.total)
              );
            else waterTraceValues.push(10);
            operationTraceValues.push(i + 1);
          }
          let productTrace = {
            x: operationTraceValues,
            y: productTraceValues,
            type: "bar",
            name: "Producto (Kgs)",
            text: productTraceValues.map(String),
            textposition: "auto",
            //hoverinfo: 'none',
            opacity: 0.5,
            /*
                    marker: 
                    {
                        color: 'rgb(158,202,225)',
                        line: 
                        {
                            color: 'rgb(8,48,107)',
                            width: 1.5
                        }
                    }
                    */
          };

          let waterTrace = {
            x: operationTraceValues,
            y: waterTraceValues,
            type: "bar",
            name: "Agua (Lts)",
            text: waterTraceValues.map(String),
            textposition: "auto",
            //hoverinfo: 'none',
            /*
                    marker: 
                    {
                        color: 'rgba(58,200,225,.5)',
                        line: 
                        {
                            color: 'rgb(8,48,107)',
                            width: 1.5
                        }
                    }
                    */
          };
          // Add traces to array of traces
          gantt_traces.push(productTrace);
          gantt_traces.push(waterTrace);
          // Log
          console.log("Gantt Traces -> ", gantt_traces);
          console.log("Gantt Layout -> ", gantt_layout);
          // Make assignation to global variable of HTML component
          this.data.operations_gantt_data.data = gantt_traces;
          this.data.operations_gantt_data.layout = gantt_layout;
        },
        (err) => {
          console.log(err);
        }
      );
  }

  doBuildCampaignReportKPISection(disp, inicio, fin) {
    console.log("doBuildCampaignReportKPISection (Disp) -> ", disp);
    console.log("doBuildCampaignReportKPISection (Inicio) -> ", inicio);
    console.log("doBuildCampaignReportKPISection (Fin) -> ", fin);
    // Obtener el indicador de total de acero producido
    this.gunningsService
      .getSteelProductionsByGunningMachineBetweenDates(
        this.collectionNameSteelProduction,
        disp,
        inicio,
        fin
      )
      .subscribe(
        (data) => {
          console.log("Steel -> ", data);
          let consumptions = data.data.findConsumptionsByDispBetweenDates;
          let producedSteelTotal = 0;
          for (let i = 0; i < consumptions.length; i++) {
            let consumption = consumptions[i];
            producedSteelTotal = producedSteelTotal + consumption.consumo;
          }
          this.steelProductionQuantity = producedSteelTotal;
          this.gunningsService
            .getSteelProductionsByGunningMachineBetweenDates(
              this.collectionNameConsumptionsFrimag,
              disp,
              inicio,
              fin
            )
            .subscribe(
              (data) => {
                console.log("Frimag -> ", data);
                let consumptions = data.data.findConsumptionsByDispBetweenDates;
                let consumedFrimag = 0;
                for (let i = 0; i < consumptions.length; i++) {
                  let consumption = consumptions[i];
                  consumedFrimag = consumedFrimag + consumption.consumo;
                }
                this.consumedFrimagQuantity = consumedFrimag;
                this.gunningsService
                  .getSteelProductionsByGunningMachineBetweenDates(
                    this.collectionNameConsumptionsMagsol,
                    disp,
                    inicio,
                    fin
                  )
                  .subscribe(
                    (data) => {
                      console.log("Magsol -> ", data);
                      let consumptions =
                        data.data.findConsumptionsByDispBetweenDates;
                      let consumedMagsol = 0;
                      for (let i = 0; i < consumptions.length; i++) {
                        let consumption = consumptions[i];
                        consumedMagsol = consumedMagsol + consumption.consumo;
                      }
                      this.consumedMagsolQuantity = consumedMagsol;
                      this.gunningsService
                        .getOperationsByGunningMachineBetweenDates(
                          this.collectionNameGunningIntervals,
                          disp,
                          inicio,
                          fin
                        )
                        .subscribe(
                          (data) => {
                            let operations =
                              data.data.findIntervalsBetweenDates;
                            let consumedInmpactor = 0;
                            for (let i = 0; i < operations.length; i++) {
                              let operation = operations[i];
                              consumedInmpactor =
                                consumedInmpactor +
                                operation.campos.productoGunitadoTotal;
                            }
                            this.consumedProductQuantity = consumedInmpactor;
                            console.log(
                              "doBuildCampaignReportKPISection (Steel) -> ",
                              this.steelProductionQuantity
                            );
                            console.log(
                              "doBuildCampaignReportKPISection (Impactor) -> ",
                              this.consumedProductQuantity
                            );
                            console.log(
                              "doBuildCampaignReportKPISection (Frimag) -> ",
                              this.consumedFrimagQuantity
                            );
                            console.log(
                              "doBuildCampaignReportKPISection (Magsol) -> ",
                              this.consumedMagsolQuantity
                            );
                          },
                          (err) => {
                            console.log(err);
                          }
                        );
                    },
                    (err) => {
                      console.log(err);
                    }
                  );
              },
              (err) => {
                console.log(err);
              }
            );
        },
        (err) => {
          console.log(err);
        }
      );

    // Obtener el indicador todal de consumo de arena (de las operaciones de la campaña)
    this.gunningsService
      .getOperationsByGunningMachineBetweenDates(
        this.collectionNameGunningIntervals,
        disp,
        inicio,
        fin
      )
      .subscribe(
        (data) => {
          console.log("getOperationsByGunningMachineBetweenDates -> ", data);
          let operations = data.data.findIntervalsBetweenDates;
          let consumedProductTotal = 0;
          let consumedWaterTotal = 0;
          for (let i = 0; i < operations.length; i++) {
            let operation = operations[i];
            consumedProductTotal =
              consumedProductTotal + operation.campos.productoGunitadoTotal;
            consumedWaterTotal =
              consumedWaterTotal +
              (operation.campos.peticionAgua.media / 60) *
                (operation.fin - operation.inicio); // Caluclo de consumo a partir del caudal y duración de la operacion
          }
          this.consumedProductQuantity = Math.round(
            (consumedProductTotal * 100) / 100
          ); // Indicador en Kgs
          //this.consumedProductQuantity = this.consumedProductQuantity/1000 // Indicador en Tns
          this.consumedWaterQuantity = Math.round(
            (consumedWaterTotal * 100) / 100
          ); // Indicador en Litros
        },
        (err) => {
          console.log(err);
        }
      );
  }

  doBuildCampaignReportAlarmsSection(inicio, fin) {
    this.incidentsService.getTiposIncidente().subscribe(
      (data) => {
        console.log("getTiposIncidente -> ", data);
        let results = data.data.findTipoDatoEstados;
        let occurrences = [];
        for (let i = 0; i < results.length; i++) {
          let disp = results[i];
          if (disp.nombre == "Gunitadora") {
            for (let j = 0; j < results[i].tipoDatoEstado.length; j++) {
              if (disp.tipoDatoEstado[j].nombre.includes("FALLO")) {
                let incidente = disp.tipoDatoEstado[j];
                this.incidentsService
                  .getIncidentOccurrencesBetweenDates(
                    disp.uuid,
                    incidente.uuid,
                    inicio * 1000,
                    fin * 1000
                  )
                  .subscribe(
                    (data) => {
                      console.log("findTimeSerie DISP ->", disp.uuid);
                      console.log("findTimeSerie TD ->", incidente.nombre);
                      console.log("findTimeSerie INICIO ->", inicio * 1000);
                      console.log("findTimeSerie FIN ->", fin * 1000);
                      console.log("findTimeSerie ->", data);
                      let timeserie = data.data.findTimeSerie;
                      for (let i = 0; i < timeserie.length; i++) {
                        timeserie[i].uuid = incidente.uuid;
                        timeserie[i].alarma = incidente.nombre;
                        if (timeserie[i].valor == 1) {
                          occurrences.push(timeserie[i]);
                        }
                      }
                      console.log(
                        "Total Alarms Ocurrences OCCURRENCES -> ",
                        occurrences
                      );
                    },
                    (err) => {
                      console.log(err);
                    }
                  );
              }
            }
          }
        }
        this.data.report.alarms = occurrences;
        console.log("Alarms -> ", this.data.report.alarms);
      },
      (err) => {
        console.log(err);
      }
    );
  }

  doBuildCampaignReportHeaderSection(campaign, data) {
    this.gunningsService
      .getOperationsByGunningMachineBetweenDates(
        this.collectionNameGunningIntervals,
        campaign.disp,
        campaign.inicio,
        campaign.fin
      )
      .subscribe(
        (data) => {
          let operations = data.data.findIntervalsBetweenDates;
          this.data.report.operations = operations.length;
          this.data.report.uuid = campaign._id;
          this.data.report.id = campaign.nombre;
          this.data.report.start = campaign.inicio;
          this.data.report.end = campaign.fin;
          this.data.report.duration = campaign.fin - campaign.inicio;
          this.data.report.alarms = this.data.report.alarms;
          this.doPlotAlarmsSummaryChart(this.data.report.alarms);
        },
        (err) => {
          console.log(err);
        }
      );
  }

  doBuildGunningOperationReport(uuid) {
    this.gunningsService
      .getOperationById(this.collectionNameGunningIntervals, uuid)
      .subscribe(
        (data) => {
          let operation = data.data.findIntervalById;
          this.gunningsService
            .getCampaignByDispAndDate(
              this.collectionCampaigns,
              operation.fin,
              this.gunningDispUuid
            )
            .subscribe(
              (data) => {
                let campaign = data.data.findCampaignByDateAndDisp;
                this.doBuildOperationReportProductSection(operation);
                this.doBuildOperationReportWaterSection(operation);
                this.doBuildOperationReportAlarmsSection(operation);
                setTimeout(() => {
                  console.log(
                    "Building report for Operation UUID -> ",
                    operation._id
                  );
                  console.log("Alarms -> ", this.data.report.alarms);
                  this.doBuildReportData(
                    operation,
                    this.data.report.alarms,
                    campaign[0].nombre
                  );
                  this.isPrintEnabled = true;
                }, 10000);
              },
              (err) => {
                console.log(err);
              }
            );
        },
        (err) => {
          console.log(err);
        }
      );
  }

  doBuildOperationReportProductSection(operation) {
    this.gunningsService
      .getTimeseriesData(
        operation.disp,
        this.gunningTipoDato,
        operation.inicio * 1000,
        operation.fin * 1000
      )
      .subscribe(
        (data) => {
          console.log(data);
          let timeserie = data.data.findTimeSerie3;
          this.doBuildProductDataTimeseries(timeserie);
        },
        (err) => {
          console.log(err);
        }
      );
    this.gunningsService
      .getTimeseriesHeatMapData(
        operation.disp,
        this.gunningTipoDato,
        operation.inicio * 1000,
        operation.fin * 1000
      )
      .subscribe(
        (data) => {
          let timeserie = data.data.findTimeSerie2;
          console.log("HeatMap (product) timeserie -> ", timeserie);
          this.doBuildProductDataHeatmap(timeserie);
        },
        (err) => {
          console.log(err);
        }
      );
  }

  doBuildCampaignReportProductSection(campaign) {
    this.gunningsService
      .getTimeseriesData(
        campaign.disp,
        this.gunningTipoDato,
        campaign.inicio * 1000,
        campaign.fin * 1000
      )
      .subscribe(
        (data) => {
          console.log(data);
          let timeserie = data.data.findTimeSerie3;
          this.doBuildProductDataTimeseries(timeserie);
        },
        (err) => {
          console.log(err);
        }
      );
    this.gunningsService
      .getTimeseriesHeatMapData(
        campaign.disp,
        this.gunningTipoDato,
        campaign.inicio * 1000,
        campaign.fin * 1000
      )
      .subscribe(
        (data) => {
          let timeserie = data.data.findTimeSerie2;
          console.log("HeatMap (product) timeserie -> ", timeserie);
          this.doBuildProductDataHeatmap(timeserie);
        },
        (err) => {
          console.log(err);
        }
      );
  }

  doBuildOperationReportWaterSection(operation) {
    this.gunningsService
      .getTimeseriesData(
        operation.disp,
        this.gunningTipoDato,
        operation.inicio * 1000,
        operation.fin * 1000
      )
      .subscribe(
        (data) => {
          console.log(data);
          let timeserie = data.data.findTimeSerie3;
          console.log("getTimeseriesData -> ", timeserie);
          this.doBuildWaterDataTimeseries(timeserie);
        },
        (err) => {
          console.log(err);
        }
      );
    this.gunningsService
      .getTimeseriesHeatMapData(
        operation.disp,
        this.gunningTipoDato,
        operation.inicio * 1000,
        operation.fin * 1000
      )
      .subscribe(
        (data) => {
          let timeserie = data.data.findTimeSerie2;
          console.log("getTimeseriesHeatMapData -> ", timeserie);
          this.doBuildWaterDataHeatmap(timeserie);
        },
        (err) => {
          console.log(err);
        }
      );
  }

  doBuildCampaignReportWaterSection(campaign) {
    this.gunningsService
      .getTimeseriesData(
        campaign.disp,
        this.gunningTipoDato,
        campaign.inicio * 1000,
        campaign.fin * 1000
      )
      .subscribe(
        (data) => {
          console.log(data);
          let timeserie = data.data.findTimeSerie3;
          console.log("getTimeseriesData -> ", timeserie);
          this.doBuildWaterDataTimeseries(timeserie);
        },
        (err) => {
          console.log(err);
        }
      );
    this.gunningsService
      .getTimeseriesHeatMapData(
        campaign.disp,
        this.gunningTipoDato,
        campaign.inicio * 1000,
        campaign.fin * 1000
      )
      .subscribe(
        (data) => {
          let timeserie = data.data.findTimeSerie2;
          console.log("getTimeseriesHeatMapData -> ", timeserie);
          this.doBuildWaterDataHeatmap(timeserie);
        },
        (err) => {
          console.log(err);
        }
      );
  }

  doBuildOperationReportAlarmsSection(operation) {
    this.incidentsService.getTiposIncidente().subscribe(
      (data) => {
        console.log("getTiposIncidente -> ", data);
        let results = data.data.findTipoDatoEstados;
        let occurrences = [];
        for (let i = 0; i < results.length; i++) {
          let disp = results[i];
          if (disp.nombre == "Gunitadora") {
            for (let j = 0; j < results[i].tipoDatoEstado.length; j++) {
              if (disp.tipoDatoEstado[j].nombre.includes("FALLO")) {
                let incidente = disp.tipoDatoEstado[j];
                this.incidentsService
                  .getIncidentOccurrencesBetweenDates(
                    disp.uuid,
                    incidente.uuid,
                    operation.inicio * 1000,
                    operation.fin * 1000
                  )
                  .subscribe(
                    (data) => {
                      console.log("findTimeSerie DISP ->", disp.uuid);
                      console.log("findTimeSerie TD ->", incidente.nombre);
                      console.log(
                        "findTimeSerie INICIO ->",
                        operation.inicio * 1000
                      );
                      console.log("findTimeSerie FIN ->", operation.fin * 1000);
                      console.log("findTimeSerie ->", data);
                      let timeserie = data.data.findTimeSerie;
                      for (let i = 0; i < timeserie.length; i++) {
                        timeserie[i].uuid = incidente.uuid;
                        timeserie[i].alarma = incidente.nombre;
                        if (timeserie[i].valor == 1) {
                          occurrences.push(timeserie[i]);
                        }
                      }
                      console.log(
                        "Total Alarms Ocurrences OCCURRENCES -> ",
                        occurrences
                      );
                    },
                    (err) => {
                      console.log(err);
                    }
                  );
              }
            }
          }
        }
        this.data.report.alarms = occurrences;
        console.log("Alarms -> ", this.data.report.alarms);
      },
      (err) => {
        console.log(err);
      }
    );
  }

  doBuildReportData(operation, data, campaign) {
    console.log("Operation -> ", operation);
    this.data.report.uuid = operation._id;
    this.data.report.start = operation.inicio;
    this.data.report.end = operation.fin;
    this.data.report.duration = operation.fin - operation.inicio;
    this.data.report.product = this.doRoundNumber(
      operation.campos.productoGunitadoTotal
    );
    this.data.report.water = this.doRoundNumber(
      operation.campos.peticionAgua.total
    ); // Calulo del consumo total de agua a partir del dato de caudal por minuto
    this.data.report.alarms = data;
    this.data.report.campaign = campaign;
    this.doPlotAlarmsSummaryChart(this.data.report.alarms);
    console.log("Metadata -> ", this.data.report);
  }

  doPlotAlarmsSummaryChart(data) {
    // Initialize arrays
    let pie_x1 = [];
    let pie_y1 = [];

    let pie_data = {
      data: [],
      layout: {},
    };

    for (let i = 0; i < data.length; i++) {
      pie_x1.push(1);
      pie_y1.push(data[i].alarma);
    }
    pie_data.data.push({
      values: pie_x1,
      labels: pie_y1,
      hoverinfo: "label+percent",
      hole: 0.4,
      type: "pie",
    });
    pie_data.layout = { title: "Summary", autosize: true };
    this.data.pie_data = pie_data;
    console.log("doPlotAlarmsSummaryChart -> ", this.data.pie_data);
  }

  doRetrieveGunningProductDataById(uuid) {
    console.log(uuid);
    this.gunningsService
      .getOperationById(this.collectionNameGunningIntervals, uuid)
      .subscribe(
        (data) => {
          console.log(data);
          let operation = data.data.findIntervalById;
          this.gunningsService
            .getTimeseriesData(
              operation.disp,
              this.gunningTipoDato,
              operation.inicio * 1000,
              operation.fin * 1000
            )
            .subscribe(
              (data) => {
                console.log(data);
                let timeserie = data.data.findTimeSerie3;
                this.doBuildProductDataTimeseries(timeserie);
              },
              (err) => {
                console.log(err);
              }
            );
          this.gunningsService
            .getTimeseriesHeatMapData(
              operation.disp,
              this.gunningTipoDato,
              operation.inicio * 1000,
              operation.fin * 1000
            )
            .subscribe(
              (data) => {
                let timeserie = data.data.findTimeSerie2;
                console.log("HeatMap (product) timeserie -> ", timeserie);
                this.doBuildProductDataHeatmap(timeserie);
              },
              (err) => {
                console.log(err);
              }
            );
        },
        (err) => {
          console.log(err);
        }
      );
  }

  doRetrieveGunningWaterDataById(uuid) {
    console.log(uuid);
    this.gunningsService
      .getOperationById(this.collectionNameGunningIntervals, uuid)
      .subscribe(
        (data) => {
          console.log(data);
          let operation = data.data.findIntervalById;
          this.gunningsService
            .getTimeseriesData(
              operation.disp,
              this.gunningTipoDato,
              operation.inicio * 1000,
              operation.fin * 1000
            )
            .subscribe(
              (data) => {
                console.log(data);
                let timeserie = data.data.findTimeSerie3;
                this.doBuildWaterDataTimeseries(timeserie);
              },
              (err) => {
                console.log(err);
              }
            );
          this.gunningsService
            .getTimeseriesHeatMapData(
              operation.disp,
              this.gunningTipoDato,
              operation.inicio * 1000,
              operation.fin * 1000
            )
            .subscribe(
              (data) => {
                let timeserie = data.data.findTimeSerie2;
                console.log("HeatMap (water) timeserie -> ", timeserie);
                this.doBuildWaterDataHeatmap(timeserie);
              },
              (err) => {
                console.log(err);
              }
            );
        },
        (err) => {
          console.log(err);
        }
      );
  }

  doBuildProductDataTimeseries(data) {
    // Initialize arrays
    let product_graph_data = {
      data: [],
      layout: {},
    };

    let product_graph_x = [];
    let product_graph_y = [];

    let cantidad = 0;

    for (let j = 0; j < data.length; j++) {
      if (Number.isInteger(j / 59) && j > 0) {
        // Cada minuto
        product_graph_x.push(j);
        product_graph_y.push(cantidad + data[j].productoGutinado);
        cantidad = 0;
      } else if (j == data.length - 1) {
        // Ultimo segundo
        product_graph_x.push(j);
        product_graph_y.push(cantidad + data[j].productoGutinado);
      } // Cada segundo que no es minuto, se obtiene el acumulado
      else {
        cantidad = cantidad + data[j].productoGutinado;
      }
      /*
            product_graph_x.push(j);
            product_graph_y.push(data[j].productoGutinado);
            */
    }

    product_graph_data.data.push({
      x: product_graph_x,
      y: product_graph_y,
      type: "scatter",
    });
    product_graph_data.layout = { title: "Operación: " + this.data.id + ")" };
    this.data.product_graph_data = product_graph_data;
  }

  doBuildProductDataHeatmap(data) {
    // Initialize arrays
    let product_heatmap_x = [];
    let product_heatmap_y = [];
    let heatmap_anotations = [];

    let colorscaleValue = [
      [0, "#3D9970"],
      [1, "#001f3f"],
    ];
    let HEATMAP_PRODUCT_DATA = [];

    let product_heatmap_data = {
      data: [],
      layout: {},
    };

    const HEATMAP_X_AXIS_LABELS_ARRAY = [
      "P12<br>(COMB-1)",
      "P11",
      "P10",
      "P9<br>(COMB-2)",
      "P8",
      "P7<br>EBT",
      "P6",
      "P5<br>(COMB-4)",
      "P4",
      "P3<br>(COMB-3)",
      "P2",
      "P1",
    ];
    const HEATMAP_Y_AXIS_LABELS_ARRAY = ["L1", "L2", "L3", "L4"];

    // Build Data Array
    if (data == -1) {
      HEATMAP_PRODUCT_DATA = [];
      let samples = 12;
      let zones = 4;
      let precision = 100;
      for (let i = 0; i < zones; i++) {
        HEATMAP_PRODUCT_DATA[i] = [];
        for (let j = 0; j < samples; j++) {
          HEATMAP_PRODUCT_DATA[i][j] =
            Math.floor(
              Math.random() * (10 * precision - 1 * precision) + 1 * precision
            ) /
            (1 * precision);
        }
      }
    } else {
      // Inicializamos array
      HEATMAP_PRODUCT_DATA = [];
      let samples = 12;
      let zones = 4;
      for (let i = 0; i < zones; i++) {
        HEATMAP_PRODUCT_DATA[i] = [];
        for (let j = 0; j < samples; j++) {
          HEATMAP_PRODUCT_DATA[i][j] = 0;
        }
      }

      // Actualizamos array con los datos obtenidos desde el back
      for (let i = 0; i < data.length; i++) {
        let element1 = data[i];
        console.log(element1);
        for (let j = 0; j < element1.acumuladosArray.length; j++) {
          let element2 = element1.acumuladosArray[j];
          console.log(element2);
          HEATMAP_PRODUCT_DATA[element1.ySector][element2.xSector] =
            element2.data.productoGutinado;
        }
      }
      console.log("HEATMAP_PRODUCT_DATA -> ", HEATMAP_PRODUCT_DATA);
    }

    // Initialize X and Y Axis of the heampa (Sectors)
    for (let i = 0; i < HEATMAP_PRODUCT_DATA.length; i++) {
      //product_heatmap_y.push(i);
      for (let j = 0; j < HEATMAP_PRODUCT_DATA[i].length; j++) {
        //product_heatmap_x.push(j);
        heatmap_anotations.push({
          xref: "x1",
          yref: "y1",
          x: j,
          y: i,
          text: HEATMAP_PRODUCT_DATA[i][j],
          font: {
            family: "Arial",
            size: 10,
            color: "rgb(255,255,255)",
          },
          showarrow: false,
        });
      }
    }

    product_heatmap_data.data.push({
      x: HEATMAP_X_AXIS_LABELS_ARRAY,
      y: HEATMAP_Y_AXIS_LABELS_ARRAY,
      z: HEATMAP_PRODUCT_DATA,
      type: "heatmap",
      colorscale: colorscaleValue,
      showscale: true,
    });

    product_heatmap_data.layout = {
      annotations: heatmap_anotations,
      xaxis: {
        ticks: "",
        side: "top",
        title: "Pailas",
      },
      yaxis: {
        ticks: "",
        title: "Niveles",
      },
    };
    this.data.product_heatmap_data = product_heatmap_data;
  }

  doBuildWaterDataTimeseries(data) {
    // Initialize arrays
    let water_graph_data = {
      data: [],
      layout: {},
    };

    let water_graph_x = [];
    let water_graph_y = [];

    let cantidad = 0;

    for (let j = 0; j < data.length; j++) {
      if (Number.isInteger(j / 59) && j > 0) {
        // Cada minuto
        water_graph_x.push(j);
        water_graph_y.push(cantidad + data[j].peticionAgua);
        cantidad = 0;
      } else if (j == data.length - 1) {
        // Ultimo segundo
        water_graph_x.push(j);
        water_graph_y.push(cantidad + data[j].peticionAgua);
      } // Cada segundo que no es minuto, se obtiene el acumulado
      else {
        cantidad = cantidad + data[j].peticionAgua;
      }
      /*
            water_graph_x.push(j);
            water_graph_y.push(data[j].peticionAgua);
            */
    }

    water_graph_data.data.push({
      x: water_graph_x,
      y: water_graph_y,
      type: "scatter",
    });
    water_graph_data.layout = { title: "Operación: " + this.data.id + ")" };
    this.data.water_graph_data = water_graph_data;
  }

  doBuildWaterDataHeatmap(data) {
    // Initialize arrays
    let water_heatmap_x = [];
    let water_heatmap_y = [];
    let heatmap_anotations = [];

    let colorscaleValue = [
      [0, "#3D9970"],
      [1, "#001f3f"],
    ];
    let HEATMAP_WATER_DATA = [];

    let water_heatmap_data = {
      data: [],
      layout: {},
    };

    const HEATMAP_X_AXIS_LABELS_ARRAY = [
      "P12<br>(COMB-1)",
      "P11",
      "P10",
      "P9<br>(COMB-2)",
      "P8",
      "P7<br>EBT",
      "P6",
      "P5<br>(COMB-4)",
      "P4",
      "P3<br>(COMB-3)",
      "P2",
      "P1",
    ];
    const HEATMAP_Y_AXIS_LABELS_ARRAY = ["L1", "L2", "L3", "L4"];

    if (data == -1) {
      HEATMAP_WATER_DATA = [];
      let samples = 24;
      let zones = 5;
      let precision = 100;
      for (let i = 0; i < zones; i++) {
        this.HEATMAP_WATER_DATA[i] = [];
        for (let j = 0; j < samples; j++) {
          HEATMAP_WATER_DATA[i][j] =
            Math.floor(
              Math.random() * (10 * precision - 1 * precision) + 1 * precision
            ) /
            (1 * precision);
        }
      }
    } else {
      // Inicializamos array
      HEATMAP_WATER_DATA = [];
      let samples = 12;
      let zones = 4;
      for (let i = 0; i < zones; i++) {
        HEATMAP_WATER_DATA[i] = [];
        for (let j = 0; j < samples; j++) {
          HEATMAP_WATER_DATA[i][j] = 0;
        }
      }

      // Actualizamos array con los datos obtenidos desde el back
      for (let i = 0; i < data.length; i++) {
        let element1 = data[i];
        console.log(element1);
        for (let j = 0; j < element1.acumuladosArray.length; j++) {
          let element2 = element1.acumuladosArray[j];
          console.log(element2);
          HEATMAP_WATER_DATA[element1.ySector][element2.xSector] =
            this.doRoundNumber(element2.data.peticionAgua);
        }
      }
      console.log("HEATMAP_WATER_DATA -> ", HEATMAP_WATER_DATA);
    }

    // Initialize X and Y Axis of the heampa (Sectors)
    for (let i = 0; i < HEATMAP_WATER_DATA.length; i++) {
      //water_heatmap_x.push(i);
      for (let j = 0; j < HEATMAP_WATER_DATA[i].length; j++) {
        //water_heatmap_y.push(j);
        heatmap_anotations.push({
          xref: "x1",
          yref: "y1",
          x: j,
          y: i,
          text: HEATMAP_WATER_DATA[i][j],
          font: {
            family: "Arial",
            size: 10,
            color: "rgb(255,255,255)",
          },
          showarrow: false,
        });
      }
    }

    water_heatmap_data.data.push({
      x: HEATMAP_X_AXIS_LABELS_ARRAY,
      y: HEATMAP_Y_AXIS_LABELS_ARRAY,
      z: HEATMAP_WATER_DATA,
      type: "heatmap",
      colorscale: colorscaleValue,
      showscale: true,
    });

    water_heatmap_data.layout = {
      annotations: heatmap_anotations,
      xaxis: {
        ticks: "",
        side: "top",
        title: "Pailas",
      },
      yaxis: {
        ticks: "",
        title: "Niveles",
      },
    };
    this.data.water_heatmap_data = water_heatmap_data;
  }

  doAddSteelProduction() {
    let disp = this.addSteelProductionForm.get("dispUuid").value;
    let fecha = this.addSteelProductionForm.get("consumptionTimestamp").value;
    let consumo = parseInt(
      this.addSteelProductionForm.get("steelConsumption").value
    );
    let coladas = parseInt(
      this.addSteelProductionForm.get("steelCastings").value
    );
    this.gunningsService
      .insertSteelProductionByGunningMachine(
        this.collectionNameSteelProduction,
        disp,
        consumo,
        fecha,
        coladas
      )
      .subscribe(
        (data) => {
          this.gunningsService
            .getSteelProductionsByGunningMachine(
              this.collectionNameSteelProduction,
              disp
            )
            .subscribe(
              (data) => {
                let consumptions = data.data.findConsumptionsByDisp;
                this.dialog
                  .getDialogById("addSteelProductionDialog")
                  .close(consumptions);
              },
              (err) => {
                console.log(err);
              }
            );
        },
        (err) => {
          console.log(err);
        }
      );
  }

  doAddFrimagConsumption() {
    let disp = this.addFrimagConsumptionForm.get("dispUuid").value;
    let fecha = this.addFrimagConsumptionForm.get("consumptionTimestamp").value;
    let consumo = parseInt(
      this.addFrimagConsumptionForm.get("frimagConsumption").value
    );
    this.gunningsService
      .insertFrimagConsumptionByGunningMachine(
        this.collectionNameConsumptionsFrimag,
        disp,
        consumo,
        fecha
      )
      .subscribe(
        (data) => {
          this.gunningsService
            .getFrimagConsumptionsByGunningMachine(
              this.collectionNameConsumptionsFrimag,
              disp
            )
            .subscribe(
              (data) => {
                let consumptions = data.data.findConsumptionsByDisp;
                this.dialog
                  .getDialogById("addFrimagConsumptionDialog")
                  .close(consumptions);
              },
              (err) => {
                console.log(err);
              }
            );
        },
        (err) => {
          console.log(err);
        }
      );
  }

  doAddMagsolConsumption() {
    let disp = this.addMagsolConsumptionForm.get("dispUuid").value;
    let fecha = this.addMagsolConsumptionForm.get("consumptionTimestamp").value;
    let consumo = parseInt(
      this.addMagsolConsumptionForm.get("magsolConsumption").value
    );
    this.gunningsService
      .insertMagsolConsumptionByGunningMachine(
        this.collectionNameConsumptionsMagsol,
        disp,
        consumo,
        fecha
      )
      .subscribe(
        (data) => {
          this.gunningsService
            .getMagsolConsumptionsByGunningMachine(
              this.collectionNameConsumptionsMagsol,
              disp
            )
            .subscribe(
              (data) => {
                let consumptions = data.data.findConsumptionsByDisp;
                this.dialog
                  .getDialogById("addMagsolConsumptionDialog")
                  .close(consumptions);
              },
              (err) => {
                console.log(err);
              }
            );
        },
        (err) => {
          console.log(err);
        }
      );
  }

  doAddCampaign() {
    console.log("Add Campaign (Form) -> ", this.addCampaignForm.getRawValue());
    console.log(
      "Add Campaign (Disp) -> ",
      this.addCampaignForm.get("dispUuid").value
    );
    console.log(
      "Add Campaign (Name) -> ",
      this.addCampaignForm.get("campaignName").value
    );
    console.log(
      "Add Campaign (Start) -> ",
      this.addCampaignForm.get("campaignStartDate").value
    );
    console.log(
      "Add Campaign (End) -> ",
      this.addCampaignForm.get("campaignEndDate").value
    );
    this.doCheckCampaignDatesAndInsertCampaign(
      this.collectionCampaigns,
      this.addCampaignForm.get("dispUuid").value,
      this.addCampaignForm.get("campaignStartDate").value,
      this.addCampaignForm.get("campaignEndDate").value,
      this.addCampaignForm.get("campaignName").value
    );
  }

  doCheckCampaignDatesAndInsertCampaign(
    collection: string,
    disp: any,
    startDate: any,
    endDate: any,
    name: any
  ) {
    this.gunningsService
      .getCampaignsByGunningMachine(collection, disp)
      .subscribe(
        (data) => {
          let message = "";
          let error = false;
          let errorsCount = 0;
          let campaigns = data.data.findCampaignsByDisp;
          let addStartDate = new Date(startDate);
          addStartDate.setHours(6, 0, 0, 0);
          console.log("Start date for the campaign to add -> ", addStartDate);
          console.log(
            "Start date for the campaign to add (s) -> ",
            addStartDate.getTime() / 1000
          );
          let addEndDate = new Date(endDate);
          addEndDate.setHours(5, 59, 59, 0);
          console.log("End date for the campaign to add -> ", addEndDate);
          console.log(
            "End date for the campaign to add (s) -> ",
            addEndDate.getTime() / 1000
          );
          for (let i = 0; i < campaigns.length; i++) {
            let start = campaigns[i].inicio;
            let end = campaigns[i].fin;
            let startTime = addStartDate.getTime() / 1000;
            let endTime = addEndDate.getTime() / 1000;
            if (addStartDate < addEndDate) {
              if (
                startTime > start &&
                startTime < end &&
                endTime > start &&
                endTime < end
              ) {
                message =
                  message +
                  " (1) Error -> Conflicto de Fechas con la Campaña " +
                  campaigns[i].nombre;
                errorsCount++;
              } else if (
                startTime < start &&
                startTime < end &&
                endTime > start &&
                endTime < end
              ) {
                message =
                  message +
                  " (2) Error -> Conflicto de Fechas con la Campaña " +
                  campaigns[i].nombre;
                errorsCount++;
              } else if (
                startTime > start &&
                startTime < end &&
                endTime > start &&
                endTime > end
              ) {
                message =
                  message +
                  " (3) Error -> Conflicto de Fechas con la Campaña " +
                  campaigns[i].nombre;
                errorsCount++;
              } else if (
                startTime < start &&
                startTime < end &&
                endTime > start &&
                endTime > end
              ) {
                message =
                  message +
                  " (4) Error -> Conflicto de Fechas con la Campaña " +
                  campaigns[i].nombre;
                errorsCount++;
              } else {
                message =
                  message +
                  " OK -> No hay conflicto de fechas con la Campaña " +
                  campaigns[i].nombre;
              }
            }
            console.log(message);
          }
          if (errorsCount == 0) {
            this.doInsertCampaign(
              collection,
              disp,
              addStartDate.getTime(),
              addEndDate.getTime(),
              name
            );
          } else {
            console.log(
              "It is not possible to add campaing as there is a conflict with provided start and end dates..."
            );
            this.toastService.error(
              "Las fechas proporcionadas entran en conflicto con una o varias de las campañas existentes",
              "ERROR"
            );
            this.dialog.getDialogById("addCampaignDialog").close(campaigns);
          }
        },
        (err) => {
          console.log(err);
        }
      );
  }

  doInsertCampaign(
    collection: string,
    disp: any,
    inicio: any,
    fin: any,
    nombre: any
  ) {
    console.log(inicio);
    console.log(fin);
    this.gunningsService
      .insertCampaignByGunningMachine(collection, disp, inicio, fin, nombre)
      .subscribe(
        (data) => {
          console.log(data);
          this.gunningsService
            .getCampaignsByGunningMachine(collection, disp)
            .subscribe(
              (data) => {
                let campaigns = data.data.findCampaignsByDisp;
                this.dialog.getDialogById("addCampaignDialog").close(campaigns);
              },
              (err) => {
                console.log(err);
              }
            );
        },
        (err) => {
          console.log(err);
        }
      );
  }

  doEditCampaign(disp, id) {
    console.log(
      "Edit Campaign (Form) -> ",
      this.editCampaignForm.getRawValue()
    );
    console.log(
      "Edit Campaign (Disp) -> ",
      this.editCampaignForm.get("dispUuid").value
    );
    console.log(
      "Edit Campaign (Name) -> ",
      this.editCampaignForm.get("campaignName").value
    );
    console.log(
      "Edit Campaign (Start) -> ",
      this.editCampaignForm.get("campaignStartDate").value
    );
    console.log(
      "Edit Campaign (End) -> ",
      this.editCampaignForm.get("campaignEndDate").value
    );
    console.log("Do edit campaign with ID -> " + id);
    let inicio = this.editCampaignForm.get("campaignStartDate").value;
    let fin = this.editCampaignForm.get("campaignEndDate").value;
    let nombre = this.editCampaignForm.get("campaignName").value;
    let machine = this.editCampaignForm.get("dispUuid").value;
    let initCampaign = new Date(inicio);
    initCampaign.setHours(6, 0, 0, 0);
    let endCampaign = new Date(fin);
    endCampaign.setHours(5, 59, 59, 0);
    this.gunningsService
      .updateCampaignById(
        this.collectionCampaigns,
        machine,
        id,
        initCampaign.getTime(),
        endCampaign.getTime(),
        nombre
      )
      .subscribe(
        (data) => {
          console.log(data);
          this.gunningsService
            .getCampaignsByGunningMachine(this.collectionCampaigns, machine)
            .subscribe(
              (data) => {
                console.log(data);
                let campaigns = data.data.findCampaignsByDisp;
                this.dialog
                  .getDialogById("editCampaignDialog")
                  .close(campaigns);
              },
              (err) => {
                console.log(err);
              }
            );
        },
        (err) => {
          console.log(err);
        }
      );
  }

  doEditSteelProduction(disp, id) {
    console.log("Do edit conusmption with ID -> " + id);
    let fecha = this.editSteelProductionForm.get("consumptionTimestamp").value;
    let consumo = parseInt(
      this.editSteelProductionForm.get("steelConsumption").value
    );
    let coladas = parseInt(
      this.editSteelProductionForm.get("steelCastings").value
    );
    let machine = this.editSteelProductionForm.get("dispUuid").value;
    this.gunningsService
      .updateSteelProductionById(
        this.collectionNameSteelProduction,
        machine,
        id,
        fecha,
        consumo,
        coladas
      )
      .subscribe(
        (data) => {
          this.gunningsService
            .getSteelProductionsByGunningMachine(
              this.collectionNameSteelProduction,
              machine
            )
            .subscribe(
              (data) => {
                let consumptions = data.data.findConsumptionsByDisp;
                this.dialog
                  .getDialogById("editConsumptionDialog")
                  .close(consumptions);
              },
              (err) => {
                console.log(err);
              }
            );
        },
        (err) => {
          console.log(err);
        }
      );
  }

  doEditFrimagConsumption(disp, id) {
    console.log("Do edit conusmption with ID -> " + id);
    let fecha = this.editFrimagConsumptionForm.get(
      "consumptionTimestamp"
    ).value;
    let consumo = parseInt(
      this.editFrimagConsumptionForm.get("frimagConsumption").value
    );
    let machine = this.editFrimagConsumptionForm.get("dispUuid").value;
    this.gunningsService
      .updateFrimagConsumptionById(
        this.collectionNameConsumptionsFrimag,
        machine,
        id,
        fecha,
        consumo
      )
      .subscribe(
        (data) => {
          this.gunningsService
            .getSteelProductionsByGunningMachine(
              this.collectionNameConsumptionsFrimag,
              machine
            )
            .subscribe(
              (data) => {
                let consumptions = data.data.findConsumptionsByDisp;
                this.dialog
                  .getDialogById("editFrimagConsumptionDialog")
                  .close(consumptions);
              },
              (err) => {
                console.log(err);
              }
            );
        },
        (err) => {
          console.log(err);
        }
      );
  }

  doEditMagsolConsumption(disp, id) {
    console.log("Do edit conusmption with ID -> " + id);
    let fecha = this.editMagsolConsumptionForm.get(
      "consumptionTimestamp"
    ).value;
    let consumo = parseInt(
      this.editMagsolConsumptionForm.get("magsolConsumption").value
    );
    let machine = this.editMagsolConsumptionForm.get("dispUuid").value;
    this.gunningsService
      .updateMagsolConsumptionById(
        this.collectionNameConsumptionsMagsol,
        machine,
        id,
        fecha,
        consumo
      )
      .subscribe(
        (data) => {
          this.gunningsService
            .getSteelProductionsByGunningMachine(
              this.collectionNameConsumptionsMagsol,
              machine
            )
            .subscribe(
              (data) => {
                let consumptions = data.data.findConsumptionsByDisp;
                this.dialog
                  .getDialogById("editMagsolConsumptionDialog")
                  .close(consumptions);
              },
              (err) => {
                console.log(err);
              }
            );
        },
        (err) => {
          console.log(err);
        }
      );
  }

  doRemoveCampaign(disp, id) {
    console.log("Do remove campaign with ID -> " + id);
    this.gunningsService
      .deleteCampaignById(this.collectionCampaigns, disp, id)
      .subscribe(
        (data) => {
          console.log(data);
          this.gunningsService
            .getCampaignsByGunningMachine(this.collectionCampaigns, disp)
            .subscribe(
              (data) => {
                let campaigns = data.data.findCampaignsByDisp;
                this.dialog
                  .getDialogById("removeCampaignDialog")
                  .close(campaigns);
              },
              (err) => {
                console.log(err);
              }
            );
        },
        (err) => {
          console.log(err);
        }
      );
  }

  doRemoveSteelProduction(disp, id) {
    console.log("Do remove consumption with ID -> " + id);
    this.gunningsService
      .deleteSteelProductionById(this.collectionNameSteelProduction, disp, id)
      .subscribe(
        (data) => {
          this.gunningsService
            .getSteelProductionsByGunningMachine(
              this.collectionNameSteelProduction,
              disp
            )
            .subscribe(
              (data) => {
                let consumptions = data.data.findConsumptionsByDisp;
                this.dialog
                  .getDialogById("removeSteelProductionDialog")
                  .close(consumptions);
              },
              (err) => {
                console.log(err);
              }
            );
        },
        (err) => {
          console.log(err);
        }
      );
  }

  doRemoveFrimagConsumption(disp, id) {
    console.log("Do remove consumption with ID -> " + id);
    this.gunningsService
      .deleteFrimagConsumptionById(
        this.collectionNameConsumptionsFrimag,
        disp,
        id
      )
      .subscribe(
        (data) => {
          this.gunningsService
            .getFrimagConsumptionsByGunningMachine(
              this.collectionNameConsumptionsFrimag,
              disp
            )
            .subscribe(
              (data) => {
                let consumptions = data.data.findConsumptionsByDisp;
                this.dialog
                  .getDialogById("removeFrimagConsumptionDialog")
                  .close(consumptions);
              },
              (err) => {
                console.log(err);
              }
            );
        },
        (err) => {
          console.log(err);
        }
      );
  }

  doRemoveMagsolConsumption(disp, id) {
    console.log("Do remove consumption with ID -> " + id);
    this.gunningsService
      .deleteMagsolConsumptionById(
        this.collectionNameConsumptionsMagsol,
        disp,
        id
      )
      .subscribe(
        (data) => {
          this.gunningsService
            .getMagsolConsumptionsByGunningMachine(
              this.collectionNameConsumptionsMagsol,
              disp
            )
            .subscribe(
              (data) => {
                let consumptions = data.data.findConsumptionsByDisp;
                this.dialog
                  .getDialogById("removeMagsolConsumptionDialog")
                  .close(consumptions);
              },
              (err) => {
                console.log(err);
              }
            );
        },
        (err) => {
          console.log(err);
        }
      );
  }

  doTransformDate(stringDate) {
    if (stringDate != null && stringDate != "") {
      let d = new Date(stringDate);
      return d.toLocaleString();
    }
  }

  doTransformDate2(stringDate) {
    if (stringDate != null && stringDate != "") {
      let d = new Date(stringDate);
      return d.toISOString().replace(/T/, " ").replace(/\..+/, "");
    }
  }

  doRoundNumber(number) {
    if (number != null) {
      number = Math.round(number * 100) / 100;
    }
    return number;
  }

  doPrintOperationReport() {
    // We need to open dialog with spinner
    this.dialog.open(GunningsModalComponent, {
      width: "25%",
      id: "printOperationReportDialog",
      data: {
        title: "Generando Informe de Producción (Operación)...",
        wait: true,
      },
    });
    // Initial configuration for Exporting PDF
    this.pdf = new jsPDF("p", "pt", "a4");
    this.length = this.report_divs_operation.length;
    this.counter = -1;

    // Call
    this.doGeneratePDF(0);
  }

  doPrintCampaignReport() {
    // We need to open dialog with spinner
    this.dialog.open(GunningsModalComponent, {
      width: "25%",
      id: "printCampaignReportDialog",
      data: {
        title: "Generando Informe de Producción (Campaña)...",
        wait: true,
      },
    });
    // Initial configuration for Exporting PDF
    this.pdf = new jsPDF("p", "pt", "a4");
    this.length = this.report_divs_campaign.length;
    this.counter = -1;

    // Call
    this.doGeneratePDF(1);
  }

  doGeneratePDF(option) {
    let content;
    console.log("Page -> " + this.counter);
    if (this.counter >= 0) {
      if (option == 0) console.log(this.report_divs_operation[this.counter]);
      else console.log(this.report_divs_campaign[this.counter]);
      /*
            content = document.getElementById(this.report_header);
            content = content.after(document.getElementById(this.report_divs[this.counter]));
            */
      if (option == 0)
        content = document.getElementById(
          this.report_divs_operation[this.counter]
        );
      else
        content = document.getElementById(
          this.report_divs_campaign[this.counter]
        );
    } else {
      console.log(this.report_header);
      content = document.getElementById(this.report_header);
    }
    console.log(content);
    const options = { background: "white", scale: 3 };
    html2canvas(content, options)
      .then((canvas) => {
        // Retrieve content from HTML
        var contentPDFFromHTML = canvas.toDataURL("image/png");

        // Adjust Variables
        var imgWidth = 210;
        var pageHeight = 295;
        var imgHeight = (canvas.height * imgWidth) / canvas.width;
        var heightLeft = imgHeight;

        // PDF Adjustment
        const bufferX = 15;
        const bufferY = 15;
        const imgProps = (this.pdf as any).getImageProperties(
          contentPDFFromHTML
        );
        const pdfWidth = this.pdf.internal.pageSize.getWidth() - 2 * bufferX;
        const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

        if (this.counter < 0) {
          this.headerPDFContent = contentPDFFromHTML;
          this.headerContentHeight = pdfHeight;
        }

        // Add Content to PDF
        if (this.counter >= 0) {
          console.log("Adding images for page -> " + this.counter);
          console.log("Using HTML Header Content -> " + this.headerPDFContent);
          console.log("Using HTML Body Content -> " + contentPDFFromHTML);
          this.pdf.addImage(
            this.headerPDFContent,
            "PNG",
            bufferX,
            bufferY,
            pdfWidth,
            this.headerContentHeight,
            undefined,
            "FAST"
          );
          this.pdf.addImage(
            contentPDFFromHTML,
            "PNG",
            bufferX,
            bufferY + this.headerContentHeight,
            pdfWidth,
            pdfHeight,
            undefined,
            "FAST"
          );
        } else {
          //this.pdf.addImage(contentPDFFromHTML, 'PNG', bufferX, bufferY, pdfWidth, pdfHeight, undefined, 'FAST');
        }

        // Increase counter
        this.counter++;

        // Control if new page needed, else generate the pdf
        if (this.counter < this.length) {
          if (this.counter > 0) this.pdf.addPage();
          return false;
        } else {
          return true;
        }
      })
      .then((result) => {
        if (result) {
          console.log(
            "Generating PDF with a content of " + this.counter + " pages"
          );
          this.pdf.save(
            option == 0 ? "report_operacion.pdf" : "report_campana.pdf"
          );
          if (option == 0)
            this.dialog.getDialogById("printOperationReportDialog").close();
          else this.dialog.getDialogById("printCampaignReportDialog").close(); // Cerramos ventana modal de aviso de generación de informe
          this.dialog.closeAll(); // Cerramos ventana modal 1
        } else {
          console.log(
            "Calling again doGeneratePDF for Page -> " + (this.counter + 1)
          );
          this.doGeneratePDF(option);
        }
      });
  }
}
